import WebhookIcon from '@mui/icons-material/Webhook';
import KeyIcon from '@mui/icons-material/Key';
import TagIcon from '@mui/icons-material/Tag';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
// routes
import { PATH_DASHBOARD } from '../../../routes/paths';
// components
import SvgIconStyle from '../../../components/SvgIconStyle';

// ----------------------------------------------------------------------

const getIcon = (name) => <SvgIconStyle src={`/icons/${name}.svg`} sx={{ width: 1, height: 1 }} />;

const ICONS = {
  blog: getIcon('ic_blog'),
  cart: getIcon('ic_cart'),
  chat: getIcon('ic_chat'),
  mail: getIcon('ic_mail'),
  user: getIcon('ic_user'),
  kanban: getIcon('ic_kanban'),
  alg: getIcon('algorithm'),
  banking: <CreditCardIcon  sx={{ width: 1, height: 1 }}/>,
  booking: <CreditCardIcon  sx={{ width: 1, height: 1 }}/>,
  invoice: getIcon('ic_invoice'),
  calendar: getIcon('ic_calendar'),
  ecommerce: getIcon('ic_ecommerce'),
  analytics: getIcon('ic_analytics'),
  dashboard: getIcon('ic_dashboard'),
  api: <KeyIcon sx={{ width: 1, height: 1 }}/>,
  webhook: <WebhookIcon sx={{ width: 1, height: 1 }}/>,
  hash: <TagIcon sx={{ width: 1, height: 1 }}/>,
  account: <AccountTreeIcon sx={{ width: 1, height: 1 }}/>,
};

const navConfig = [
  // GENERAL
  // ----------------------------------------------------------------------
  {
    subheader: 'general',
    items: [
      { title: 'ads', path: PATH_DASHBOARD.general.ads, icon: ICONS.account },
      { title: 'offers', path: PATH_DASHBOARD.general.offers, icon: ICONS.invoice },
      { title: 'placements', path: PATH_DASHBOARD.general.placements, icon: ICONS.analytics },
      { title: 'Creative Selection', path: PATH_DASHBOARD.general.creativeMethod, icon: ICONS.alg },
      { title: 'Creative Uploads', path: PATH_DASHBOARD.general.creativeUploads, icon: ICONS.mail },
    ],
  },


];

export default navConfig;
